import React from 'react';
import type { ManagedCurriculum } from '../../../curriculum/managedCurricula';

interface DemoInfoViewProps {
  curriculum: ManagedCurriculum;
}

const categoryLabel = (value?: ManagedCurriculum['demoCategory']) => ({
  lunch: 'Lunch', booth: 'Booth', assembly: 'Assembly', classroom: 'Classroom', conference: 'Conference', other: 'Other',
}[value || 'other']);

const DemoInfoView: React.FC<DemoInfoViewProps> = ({ curriculum }) => {
  const level = curriculum.levels[0];
  const videoUrl = level?.video?.url || level?.videoUrl;
  const minHours = curriculum.durationMinHours ?? curriculum.durationHours;
  const maxHours = curriculum.durationMaxHours ?? curriculum.durationHours;
  const durationLabel = minHours && maxHours
    ? `${minHours}${minHours === maxHours ? '' : `–${maxHours}`} hour${minHours === maxHours && minHours === 1 ? '' : 's'}`
    : minHours || maxHours ? `${minHours || maxHours} hours` : '';

  return <div className="cd-demo-info">
    <header className="cd-demo-info-head">
      <div><span className="cd-demo-category">{categoryLabel(curriculum.demoCategory)}</span><h1>{curriculum.title}</h1></div>
      {durationLabel ? <span>{durationLabel}</span> : null}
    </header>

    {curriculum.description ? <p className="cd-demo-description">{curriculum.description}</p> : null}

    {curriculum.referencePdf?.url ? <section className="cd-demo-pdf" aria-label="Main reference PDF">
      <div><h2>Main reference PDF</h2><a href={curriculum.referencePdf.url} target="_blank" rel="noreferrer">Open in a new tab ↗</a></div>
      <iframe title={curriculum.referencePdf.title || 'Demo reference PDF'} src={curriculum.referencePdf.url} />
    </section> : <div className="cd-banner cd-banner-warn">No main reference PDF has been added to this demo yet.</div>}

    <div className="cd-demo-details">
      <section><h2>{level?.title || 'Demo overview'}</h2>{level?.briefSummary ? <p>{level.briefSummary}</p> : null}</section>
      {videoUrl ? <section><h2>Video</h2><a className="cd-btn" href={videoUrl} target="_blank" rel="noreferrer">Open demo video ↗</a></section> : null}
      {level?.teacherNotes ? <section><h2>Demo notes</h2><div dangerouslySetInnerHTML={{ __html: level.teacherNotes }} /></section> : null}
      {level?.additionalNotes ? <section><h2>Additional notes</h2><div dangerouslySetInnerHTML={{ __html: level.additionalNotes }} /></section> : null}
    </div>
  </div>;
};

export default DemoInfoView;
